import { all } from 'redux-saga/effects';

import homeSaga from '../../views/app-views/home/sagas';

export default function* rootSaga() {
  yield all([
    // add sagas here
    homeSaga(),
  ]);
}
